import React from 'react';
import { Box, Typography } from '@material-ui/core';

interface MessageBubbleProps {
  body: string;
  inbound: boolean;
  caption: string;
}

/**
 * The single message bubble used by every communications surface: the profile dialog's
 * CommunicationDetailDialog, the Inbox thread panel and the Sent message panel. Keep them
 * rendering through this so a styling change lands in all three at once.
 */
export const MessageBubble = ({ body, inbound, caption }: MessageBubbleProps) => (
  <Box>
    <Box display='flex' justifyContent={inbound ? 'flex-start' : 'flex-end'} mb='4px'>
      <Box
        style={{
          backgroundColor: inbound ? '#e0e0e0' : '#1976d2',
          color: inbound ? '#333' : 'white',
          padding: '8px 12px',
          borderRadius: inbound ? '18px 18px 18px 4px' : '18px 18px 4px 18px',
          maxWidth: '70%',
          wordBreak: 'break-word',
        }}
      >
        <Typography style={{ fontSize: '14px' }}>{body}</Typography>
      </Box>
    </Box>
    <Box style={{ textAlign: inbound ? 'left' : 'right', marginBottom: '16px' }}>
      <Typography style={{ color: '#666', fontSize: '12px' }}>{caption}</Typography>
    </Box>
  </Box>
);
